import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/MainStore";
import BootstrapVue from "bootstrap-vue";
import VueSilentbox from "vue-silentbox";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

import "nprogress/nprogress.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueSilentbox);

const requireComponent = require.context(
  "./components",
  false,
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, "$1"))
  );

  Vue.component(componentName, componentConfig.default || componentConfig);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
